import CNPJMask from 'components/Inputs/CNPJMask';
import CPFMask from 'components/Inputs/CPFMask';
import CurrencyMask from 'components/Inputs/CurrencyMask';
import Datepicker from 'components/Inputs/DatePicker';
import FlexSelect from 'components/Inputs/FlexSelect';
import TelephoneMask from 'components/Inputs/TelephoneMask';
import React from 'react';
import { Controller } from 'react-hook-form';
import { Input } from 'reactstrap';
import { customFieldTypes } from 'views/fieldConfigs/utils/customFieldTypes';
export const HandlerBroadcastListProtocolCustomFields = ({
  field,
  control,
  optionsCustomFields,
  setValue,
  index,
  watch
}) => {
  const isDefaultType =
    watch(`protocol.${field.name}.type`) === 'default_values';

  const isFirstMessage =
    watch(`protocol.${field.name}.type`) === 'first_answer';
  return (
    <>
      {field.type === customFieldTypes.TEXT && (
        <Controller
          as={Input}
          type="text"
          disabled={isFirstMessage}
          control={control}
          name={`protocol.${field.name}.value`}
          defaultValue=""
          rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
        />
      )}

      {field.type === customFieldTypes.LIST &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={optionsCustomFields[field.name] || []}
                isMulti={false}
                closeMenuOnSelect={true}
                value={props.value}
                valueController={setValue}
                fieldName={`protocol.${field.name}.value`}
                labelName="label"
                valueName="value"
                disabled={isFirstMessage}
              />
            )}
            name={`protocol.${field.name}.value`}
            control={control}
            disabled={field.isRequired}
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}

      {field.type === customFieldTypes.DATE &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <div style={{ position: 'relative', zIndex: '1' }}>
                <Datepicker
                  tabIndex={index}
                  fieldName={`protocol.${field.name}.value`}
                  valueController={setValue}
                  defaultValue={props.value}
                  disabled={isFirstMessage}
                  value={props.value}
                />
              </div>
            )}
            control={control}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}

      {field.type === customFieldTypes.MULTIPLE &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <FlexSelect
                tabIndex={index}
                dataOptions={optionsCustomFields[field.name] || []}
                isMulti={true}
                isClearable={true}
                value={props.value || ''}
                valueController={setValue}
                defaultValue=""
                closeMenuOnSelect={false}
                fieldName={`protocol.${field.name}.value`}
                labelName="label"
                valueName="value"
                portalTarget={true}
                disabled={isFirstMessage}
              />
            )}
            control={control}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
          />
        ))}

      {field.type === customFieldTypes.NUMERIC &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <Input
                tabIndex={index}
                value={props.value}
                onChange={props.onChange}
                type="number"
                placeholder={field.label}
                disabled={isFirstMessage}
              />
            )}
            control={control}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}

      {field.type === customFieldTypes.CURRENCY &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <CurrencyMask
                tabIndex={index}
                valueController={setValue}
                value={props.value}
                disabled={isFirstMessage}
                fieldName={`protocol.${field.name}.value`}
              />
            )}
            control={control}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            disabled={isFirstMessage}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
          />
        ))}

      {field.type === customFieldTypes.HOUR &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <Input
                tabIndex={index}
                value={props.value}
                onChange={props.onChange}
                type="time"
                step="2"
                placeholder={field.label}
                disabled={isFirstMessage}
              />
            )}
            control={control}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}

      {field.type === customFieldTypes.TELEPHONE &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <TelephoneMask
                tabIndex={index}
                valueController={setValue}
                fieldName={`protocol.${field.name}.value`}
                value={props.value}
                placeholder="(DDD) 0000-0000"
                disabled={isFirstMessage}
              />
            )}
            control={control}
            defaultValue=""
            rules={{
              required: !isFirstMessage ? 'Campo obrigatório' : false,
              validate: (value) => {
                if (!value) return true;
                let phoneFormated = value.replace(/\D/g, '');
                phoneFormated = phoneFormated.replace(/^0/, '');

                if (phoneFormated.length < 10 && phoneFormated.length > 0) {
                  return 'Telefone inválido';
                }
                return true;
              }
            }}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}
      {field.type === customFieldTypes.CPF &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <CPFMask
                tabIndex={index}
                valueController={setValue}
                fieldName={field.name}
                value={props.value}
                placeholder="000.000.000-00"
                disabled={isFirstMessage}
              />
            )}
            control={control}
            defaultValue=""
            rules={{
              required: !isFirstMessage ? 'Campo obrigatório' : false,
              validate: (value) => {
                if (!value) return true;
                let cpfFormated = value.replace(/\D/g, '');
                if (!cpfFormated) return true;
                if (cpfFormated.length !== 11) return 'CPF inválido';
                return true;
              }
            }}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}
      {field.type === customFieldTypes.CNPJ &&
        (isDefaultType ? (
          <Controller
            render={(props) => (
              <CNPJMask
                tabIndex={index}
                valueController={setValue}
                fieldName={field.name}
                value={props.value}
                placeholder="00.000.000/0001-00"
                disabled={isFirstMessage}
              />
            )}
            control={control}
            defaultValue=""
            rules={{
              required: !isFirstMessage
                ? { required: 'Campo obrigatório' }
                : {},
              validate: (value) => {
                if (!value) return true;
                let cnpjFormated = value.replace(/\D/g, '');
                if (!cnpjFormated) return true;
                if (cnpjFormated.length !== 14) return 'CNPJ inválido';
                return true;
              }
            }}
            name={`protocol.${field.name}.value`}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}
      {field.type === customFieldTypes.LINK &&
        (isDefaultType ? (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ) : (
          <Controller
            as={Input}
            type="text"
            control={control}
            name={`protocol.${field.name}.value`}
            defaultValue=""
            rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
            disabled={isFirstMessage}
          />
        ))}
      {field.type === customFieldTypes.TEXTAREA && (
        <Controller
          as={Input}
          type="textarea"
          control={control}
          name={`protocol.${field.name}.value`}
          defaultValue=""
          rules={!isFirstMessage ? { required: 'Campo obrigatório' } : {}}
          disabled={isFirstMessage}
        />
      )}
    </>
  );
};
